module.exports = __webpack_public_path__ + "static/media/boop_pack.d5cc29df.png";